import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BoxDiv } from './box';
import { scoreToColor } from './util';

const Container = styled(BoxDiv)`
  padding: 21px 41px;
  width: 100%;
`;
const Container1 = styled(BoxDiv)`
 margin-top:12px;
 color:#ff8a5f;
 font-size:26px;
  width: 100%;
`;
const Label = styled.span`
  font-size: 27px;
  color: #6f6f6f;
  line-height: 1;
  vertical-align: middle;
`;

const Status = styled(Label)`
  padding-left: 0.5em;
  font-family: SimSun, STSong, "\\5b8b\\4f53", serif;
  font-size: 41px;
`;


class SymptomSummary extends Component {
  render() {
    const { score, symptoms } = this.props;
    return score < 81 ? (
      <Container>
        <Label>健康状态:</Label>
        <Status style={{ color: scoreToColor(score) }}>
          {
            symptoms.map(e => e.name).join('、')
          }
        </Status>
          <Container1 >
              建议找中医专家调治
          </Container1>
      </Container>

    ) : null;
  }
}

SymptomSummary.propTypes = {
  score: PropTypes.number.isRequired,
  symptoms: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
  })),
};

SymptomSummary.defaultProps = {
  symptoms: [],
};

export default SymptomSummary;



// WEBPACK FOOTER //
// ./src/components/SymptomSummary.jsx